import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeeplinksService {
  marketDeeplink$: BehaviorSubject<string>;
  customersDeeplink$: BehaviorSubject<string>;
  assetDeeplink$: BehaviorSubject<string>;
  portfolioDeeplink$: BehaviorSubject<string>;
  baselineDeeplink$: BehaviorSubject<string>;
  utilityAccountDeeplink$: BehaviorSubject<string>;
  ecrmDeeplink$: BehaviorSubject<string>;

  constructor(private apiService: ApiService) {
    this.marketDeeplink$ = new BehaviorSubject<string>('');
    this.assetDeeplink$ = new BehaviorSubject<string>('');
    this.customersDeeplink$ = new BehaviorSubject<string>('');
    this.portfolioDeeplink$ = new BehaviorSubject<string>('');
    this.baselineDeeplink$ = new BehaviorSubject<string>('');
    this.utilityAccountDeeplink$ = new BehaviorSubject<string>('');
    this.ecrmDeeplink$ = new BehaviorSubject<string>('');
  }

  async setMarketAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/markets/');
      this.marketDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load market admin url.', err);
    }
  }

  async setCustomersAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/customers/');
      this.customersDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load site admin url.', err);
    }
  }

  async setAssetAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/assets/');
      this.assetDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load asset admin url.', err);
    }
  }

  async setPortfolioAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/portfolios/');
      this.portfolioDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load portfolio admin url.', err);
    }
  }

  async setBaselineAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/baselines/');
      this.baselineDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load baseline admin url.', err);
    }
  }

  async setUtilityAccountAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/utilityAccounts/');
      this.utilityAccountDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load utility account admin url.', err);
    }
  }

  async setEcrmUrl() {
    try {
      const url = await this.apiService.get('deeplinks/ecrm/');
      this.ecrmDeeplink$.next(url);
    } catch (err) {
      console.log('Could not load ECRM url.', err);
    }
  }
}
